import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { PublishedContentModel } from "./models/published-content.model";
import { HeaderModel } from "./models/header.model";
import { HomepageModel } from "./models/homepage.model";

@Injectable({
    providedIn: "root"
})
export class DeliveryApiService {
    public constructor(
        private http: HttpClient
    ) {
    }

    public getPage$<T extends PublishedContentModel>(path: string): Observable<T> {
        return this.http.get<T>("/umbraco/delivery/api/v2/content/item" + path);
    }

    public getHeader$(): Observable<HeaderModel> {
        return this.getPage$<HomepageModel>("/").pipe(
            map(homepage => homepage.properties.Header?.items[0]?.content)
        );
    }
}
